module.exports = {"id":"189881","name":"Chris Smalling","rating":"81","photo":"./data/images/photos/4/189881.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChrisSmalling0.json
// module id = 781
// module chunks = 0